import axios from 'axios';
import config from '../config/config';

/**
 * Service for virtual event operations
 * Handles admin management of virtual events
 */

const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  if (!token) {
    throw new Error('Authentication token not available');
  }
  return { Authorization: `Bearer ${token}` };
};

const virtualEventService = {
  /**
   * Create virtual event details
   */
  createVirtualEvent: async (eventId, data) => {
    const response = await axios.post(
      `${config.API_BASE_URL}/em/v1/admin/virtual-events/${eventId}`,
      data,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  /**
   * Update virtual event details
   */
  updateVirtualEvent: async (eventId, data) => {
    const response = await axios.put(
      `${config.API_BASE_URL}/em/v1/admin/virtual-events/${eventId}`,
      data,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  /**
   * Get virtual event details
   */
  getVirtualEvent: async (eventId) => {
    const response = await axios.get(
      `${config.API_BASE_URL}/em/v1/admin/virtual-events/${eventId}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  /**
   * Delete virtual event details
   */
  deleteVirtualEvent: async (eventId) => {
    const response = await axios.delete(
      `${config.API_BASE_URL}/em/v1/admin/virtual-events/${eventId}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  /**
   * Get all virtual events
   */
  getAllVirtualEvents: async () => {
    const response = await axios.get(
      `${config.API_BASE_URL}/em/v1/admin/virtual-events`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  }
};

export default virtualEventService;
